
<div *ngIf="!error">
    Please wait...
</div>

<div *ngIf="errorMessage" class="alert alert-danger">
    {{errorMessage}}
</div>